'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactOidc = require('@axa-fr/react-oidc');

var getPath = function getPath(defaultPath) {
  var pathname = "".concat(window.location.pathname).concat(window.location.search).concat(window.location.hash);
  return pathname && pathname !== '/' ? pathname : defaultPath;
};
function logoutRedirect(userManager) {
  localStorage.setItem('userId', null);
  userManager.signoutRedirect();
}
function loginRedirect(userManager, defaultPath) {
  return userManager.signinRedirect({
    data: {
      path: getPath(defaultPath)
    }
  })
  // eslint-disable-next-line no-console
  ["catch"](function (error) {
    return console.warn('There has been an error with the OIDC Sign In Redirect', error);
  });
}

Object.defineProperty(exports, 'OidcProvider', {
    enumerable: true,
    get: function () { return reactOidc.OidcProvider; }
});
Object.defineProperty(exports, 'OidcSecure', {
    enumerable: true,
    get: function () { return reactOidc.OidcSecure; }
});
Object.defineProperty(exports, 'useOidc', {
    enumerable: true,
    get: function () { return reactOidc.useOidc; }
});
Object.defineProperty(exports, 'useOidcAccessToken', {
    enumerable: true,
    get: function () { return reactOidc.useOidcAccessToken; }
});
Object.defineProperty(exports, 'useOidcIdToken', {
    enumerable: true,
    get: function () { return reactOidc.useOidcIdToken; }
});
Object.defineProperty(exports, 'useOidcUser', {
    enumerable: true,
    get: function () { return reactOidc.useOidcUser; }
});
exports.loginRedirect = loginRedirect;
exports.logoutRedirect = logoutRedirect;
